var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"false"}},[_c('div',{staticClass:"warning-message"},[_vm._v(" Site is in use and the setup screen has been completed before. ")]),_c('button',{staticClass:"redirect-button",on:{"click":_vm.redirectToSupsis}},[_vm._v(" Go to supsis.com ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }